import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNumber4Circle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNumber4Circle"><Path d="M12.207 9.30762V13.1865H9.86328V13.0811C10.543 11.8096 11.3457 10.4854 12.1016 9.30762H12.207Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM11.1992 7.77246C10.1035 9.49512 9.03125 11.2705 8 13.1631V14.7861H12.1543V16.2275H14.1875V14.7861H15.2422V13.1104H14.1875V7.77246H11.1992Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNumber4Circle;
